import { Key } from 'react'
import { IBooking, IUser } from './models.interface'
export const BREAKPOINTS: any = {
  //TODO da rimuovere qui
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
}

export interface IControlledModalProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

export interface IEdisuIcon {
  icon?: string
  src?: string
  size?: string
}

export interface IBookingStorage extends IBooking {
  uuid: string
  booking_date: Date
  queryParams?: string
}

export interface ISearchQueryString {
  p?: Key
  c?: Key
  df?: string
  dt?: string
  ce?: string
  r?: number[]
}

export interface IAuthContext {
  user?: IUser
  changeToken?: string | null
  login: (username: string, password: string, onSuccess: Function, onError: Function) => AbortController
  logout: (onSuccess: Function) => void
  getAccessToken(): string | null
  getRefreshToken(): string | null
  getChangeToken(): string | null
  saveTokens: (accessToken: string, refreshToken: string, changeToken?: string) => void
  removeTokens: () => void
  getUserData: () => IUser | undefined
}

export type EdisuRoutesPath =
  | '/'
  | '/search'
  | '/login'
  | '/update-pw'
  | '/spid-confirm'
  | '/reset-pw'
  | '/registration'
  | '/registration-success'
  | '/modify-profile'
  | '/forgot-password'
  | '/about'
  | '/residences'
  | '/residence/:residenceId'
  | '/booking-confirm/:uuidBooking'
  | '/faq'
  | '/forgot-user'
  | '/booking-success/:uuidBooking'
  | '/error'
  | '/complete-reg'

export const LANGUAGES = [
  { value: 'it-IT', label: 'IT' },
  { value: 'en-US', label: 'EN' },
]
